import { Lock } from "Shared/appIcons";
import type { NavItem } from "Shared/Layouts/components/NavButton";
import {
	NavItemLink,
	navIconColor,
} from "Shared/Layouts/components/NavItemLink";
import { cn } from "@/lib/utils";

type Props = {
	item: NavItem;
	active: boolean;
};

/**
 * Pill-style nav button used in the horizontal topbar.
 * (The vertical drawer variant lives in `NavButton.tsx`.)
 */
export const HorizontalNavButton = ({ item, active }: Props) => {
	const Icon = item.icon;
	const disabled = !!item.disabled;
	const showHint = disabled && !!item.hint;

	const className = cn(
		"inline-flex items-center gap-2 px-3 h-9 rounded-full text-body font-medium transition-colors whitespace-nowrap no-underline",
		disabled
			? "text-muted-foreground cursor-not-allowed"
			: active
				? "bg-primary-light text-primary"
				: "text-foreground hover:bg-muted hover:text-foreground",
	);

	const iconClass = cn("w-4 h-4 flex-shrink-0", navIconColor(active, disabled));

	return (
		<NavItemLink
			item={item}
			className={className}
			tooltip
			disabledTooltipWrapperClass="inline-flex"
		>
			<Icon className={iconClass} strokeWidth={1.75} />
			<span>{item.label}</span>
			{showHint ? (
				<span className="text-muted-foreground ml-1 hidden items-center gap-1 text-micro lg:inline-flex">
					{/* `size-2.5` (not `h-2.5 w-2.5`): the shadcn Button forces every
				    svg without a `size-*` class to size-4 via
				    `[&_svg:not([class*='size-'])]:size-4`, which would blow this
				    10px lock up to 16px. */}
					<Lock className="size-2.5" />
					{item.hint}
				</span>
			) : null}
		</NavItemLink>
	);
};
